import './_aaWindow.scss';
import { EventEmitter } from '../common/utils/EventEmiter';
import { getHTML } from '../common/templatemanager/base/domManager'
import { AAContainer, AALoder, IndividualLoader, NetworkErrorToast } from '../common/templatemanager/base/aaContainer/aaContainer';
import websocketservice from '../common/services/web-socket-service'
import { DATA_EVENTS, EVENTS, EVENTS_TO_SDK, INTERNAL_EVENTS, SDK_EVENTS } from '../common/constants/events.cnst';
import rootService from '../common/services/rootService';
import EventManager from '../common/templatemanager/base/eventManager'
import fetchInstance, { updateEndPointUrl } from '../common/utils/interceptor';
import { ClassMapConstanst, DARKTHEME_COLORCODES, IdMapConstant, ProjConstants, storageConst } from '../common/constants/projConsts';
import localStorageService from '../common/services/localstorage.service';
import { chatWindow } from 'kore-web-sdk';
import {templateRenderClassService} from '../common/services/template-render-service';
import {chunkFileUploadService} from '../common/services/chunkFileUpload.service';
import { ErrorHandler } from '../common/templatemanager/tabs/ErrorBoundary/ErrorHandler';
import { WelcomeMessage } from '../common/templatemanager/tabs/automation/automation';
import { NoTabsScreen } from '../common/templatemanager/tabs/atom/actionButtons';
import { ERROR_CODES } from '../common/constants/errorcodes';
import { prefsSeed } from './config/prefs';
import { aai18nPlugin } from '../../index_plugins/aai18n';
import { en } from '../common/i18n/en';

class AAWindow extends EventEmitter{
  private socketConnection: any;
  private rootService: any;
  private localStorageService : any;
  private chatWindowInstance : any;
  private templateRenderService : any;
  private chunkFileUploadService : any;
  private languagePluginService:any;

  private timeoutId: number | undefined;

  chatEle : any;
  config: any;
  eventManager: any;
  dskSettings : any;
  pluginConfig:any;
  newSocketApproach : boolean = false;
  languagedata:any
  languages:any
  constructor() {
    super();
    ErrorHandler.initialize(this);
  }

  show(config: any) {
    const {conversationId, botId, domainURL, token, channel} = config.connectionDetails;
    if(!conversationId || !botId || !domainURL || !token || !channel){
      this.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_MISSING_REQUIRED_FIELDS']);
      return;
    }
    if(domainURL.endsWith('/')){
      config.connectionDetails.domainURL = domainURL.replace(/\/+$/, "");
    }
    this.languagePluginService = new aai18nPlugin;
    this.languages= this.languagePluginService?.config?.languageStrings;
    this.cleanupEvents();
    if(this.socketConnection?._agentAssistSocket){
      this.socketConnection.disconnect()
    }
    this.emit('DESTROY_WIDGET', {});
    this.config = config;
    this.dskSettings = config.dskSettings;
    this.subscribeToEvents();
    this.initShow(config);
    this.eventManager = new EventManager(this);
  };


  sendUserMessage(_data: any) {
    if (_data.author?.type?.toLowerCase() === 'user') {
       const sanitizedValue = this.rootService.sanitizeHTML(_data.message);
      _data.message = sanitizedValue;
      if (_data.message) {
        const conversationId = this.rootService.connectionDetails?.conversationId;
        const botId = this.rootService.connectionDetails?.botId;

        let data = {
          author: _data.author,
          type: _data.author?.type?.toUpperCase(),
          conversationId,
          value: _data.message,
          botId,
          message : _data.message
        }

        this.emit(INTERNAL_EVENTS.USER_TRANSCRIPT_MSG, data);
        this.socketConnection.emitEvents(EVENTS.user_sent_message, data);

        if(this.rootService.isAgenticCoPilotEnabled){
          return;
        }

        if (this.rootService.proactiveMode && !this.rootService.OverRideMode && !this.rootService.manualAssistOverrideMode) {
          let agent_assist_request: any = {
            author: _data.author,
            botId,
            conversationId,
            experience: this.rootService.connectionDetails?.channel,
            query: _data.message,
            positionId: this.rootService.isAutomationOnGoing ? this.rootService.currentPositionId : null
          };

          if (_data?.customData) {
            agent_assist_request['customData'] = JSON.parse(JSON.stringify(_data?.customData));
          }
          if (_data?.secureCustomData) {
            agent_assist_request['secureCustomData'] = _data?.secureCustomData;
          }
          let assistSection = this?.chatEle?.querySelector(`${ClassMapConstanst.ASSIST_SECTION}`) as HTMLElement;
          let parentNode = (assistSection?.childNodes?.length > 0 ? assistSection?.childNodes[assistSection?.childNodes?.length - 1] : assistSection) as HTMLElement;
          if(parentNode){
            this.renderIndividualLoader(parentNode);
          }
          this.socketConnection.emitEvents(EVENTS.agent_assist_request, agent_assist_request);
        }
      }
    } else {
      this.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_USER_MISSING_REQ_FIELDS']);
    }
  }

  sendAgentMessage(_data: any) {
    if (_data.author?.type?.toLowerCase() === 'agent') {
      const sanitizedValue = this.rootService.sanitizeHTML(_data.message);
      _data.message = sanitizedValue;
      if (_data.message) {
        const conversationId = this.rootService.connectionDetails?.conversationId;
        const botId = this.rootService.connectionDetails?.botId;
        let data: any = {
          author: _data.author,
          type: _data.author?.type?.toUpperCase(),
          conversationId,
          value: _data.message,
          message : _data.message,
          botId
        };
        this.emit(INTERNAL_EVENTS.AGENT_TRANSCRIPT_MSG, data);
        if (_data?.customData) {
          data['customData'] = JSON.parse(JSON.stringify(_data?.customData));
        }
        if (_data?.secureCustomData) {
          data['secureCustomData'] = _data?.secureCustomData;
        }
        this.socketConnection.emitEvents(EVENTS.agent_sent_message, data);
      }
    } else {
      this.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_AGENT_MISSING_REQ_FIELDS']);
    }
  }

  subscribeToEvents() {
    this.on(DATA_EVENTS.SETTINGS_RESPONSE, this.settingsResponseHandler);
    this.bindEvents();
  }

  private settingsResponseHandler = (data: any) => {
    if(this.newSocketApproach){
        this.handleSettingsResponse(data, this.config, this.rootService.connectionDetails.channel);
    }
  };

  handleSettingsResponse(res: any, config: any, channel: string) {
    let widgetSettings : any = {};
    if(res && res.agentAssistSettings && res.agentAssistSettings[channel]){
      this.rootService.accountId = res.accountId;
      res.agentAssistSettings = this.addBackWardCompatibility(res.agentAssistSettings);
      widgetSettings = Object.assign(res.agentAssistSettings, res.agentAssistSettings[channel]);
    }else{
      widgetSettings = this.rootService.defaultwidgetSettings;
    }
    // depends on prefs
    this.rootService.interimSummary = config.connectionDetails.interimSummary;

    
    this.rootService.aaSettings = JSON.parse(JSON.stringify(widgetSettings));
    const convItem = this.localStorageService.getStorageItem(config?.connectionDetails?.conversationId, {});
    if(convItem && Object.keys(convItem).length === 0){
      let LanguageSelect = this.rootService?.aaSettings?.languageSettings?.language;
      if(LanguageSelect === 'interactiveLang'){
        LanguageSelect = this.config?.connectionDetails?.interactiveLanguage
      }
      this.LanguageObject(LanguageSelect)
    }

    this.localStorageService.initializeLocalStorageData(this.rootService.aaSettings)

  }

  initiateSocketConnection() {
    // if(!this.newSocketApproach){
    //   this.updateSettingsProperties();
    // }
    setTimeout(() => {
      let language = this.getLanguageDetails();
      this.socketConnection.socketConnection(this.config, this.rootService.grantResponseObj, language);
    }, 100);
  }

  updateSettingsProperties(){
    let chatWindowHtml: any;
    chatWindowHtml = getHTML(AAContainer, {}, this);
    this.emit(SDK_EVENTS.BEFORE_VIEW_INIT, chatWindowHtml, { event: SDK_EVENTS.MAIN_CONTAINER, data : {} });
    this.chatEle = chatWindowHtml;
    this.render(chatWindowHtml);
    this.hideSendAndCopy();
    this.chatWindowInstance.chatEle = this.chatEle;
  }

  LanguageObject(lang:string){
    if(lang === 'interactiveLang'){
      lang = this.config?.connectionDetails?.interactiveLanguage
    }
    this.languagedata = this.languages[lang]
    const enLanguage = this.languages['en']

    try{
      for(const key of Object.keys(enLanguage)){
        if(key in this.languagedata){
          continue
        }
        else{
          this.languagedata[key] = enLanguage[key as keyof typeof enLanguage]
        }
      }
    }
    catch{
      this.languagedata = en;
    }    
  }

  initShow(config: any) {
    this.renderLoader();
    this.socketConnection = new websocketservice(this);
    this.chatWindowInstance = new chatWindow();
    this.chatWindowInstance.sendMessage = (messageText: any, options: any, serverMessageObject: any, clientMessageObject: any) => {
      console.log(messageText, options, serverMessageObject, clientMessageObject, "txt***8");
      this.emit(INTERNAL_EVENTS.TEMPLATE_CLICK, { messageText, tab: this.rootService.activeTab });
    }
    this.rootService = new rootService(this);
    this.localStorageService = new localStorageService(this);
    this.chunkFileUploadService = new chunkFileUploadService(this);
    this.rootService.connectionDetails = config.connectionDetails;
    this.templateRenderService = new templateRenderClassService(this);

    //apply branding based on theme
    let theme = this.localStorageService?.getThemeLocal();
    this.applyBranding(theme === storageConst.DARK ? DARKTHEME_COLORCODES : config.branding?.colors, theme);
    

    // this.chatWindowInstance.setBranding();   
    const { botId, conversationId, token, domainURL } = config.connectionDetails;
    const isJWE = token?.split('.')?.length === 5;

    if (botId && conversationId && token && domainURL || isJWE) {
      this.JWTSetup(config, isJWE)
        .then((data: any) => {
          this.newSocketApproach = data?.cvs;
          updateEndPointUrl(data?.invokeNewAAService);
          if (data?.cId) {
            config.connectionDetails.conversationId = data.cId;
            this.rootService.connectionDetails.conversationId = data.cId;
          }

          if(data?.isAnonymousFlowEnabled){
            this.rootService.isAnonymousFlowEnabled = true;
          }

          this.rootService.grantResponseObj = data;
          config['JWT_RESP'] = data;

          this.socketConnection.configOptions = config;

          let language = this.getLanguageDetails();
          // new socket approach
          if (data?.cvs) {
            this.initiateSocketConnection();
            
          } else {
            const { botId, channel } = config.connectionDetails;
            
            this.getAASettings(botId)
              .then((res: any) => {
                this.handleSettingsResponse(res, config, channel);
                this.initiateSocketConnection();
                this.getAAPrefsSettings(botId).then((res:any)=>{
                  this.handlePrefsResponse(res,true);
                }).catch((err:any)=>{
                  this.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_PREFS_API_FAILURE']);
                })

              }).catch((err: any) => {
                this.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_SETTINGS_API_FAILURE']);
              })
          }


        }).catch((err: any) => {
          this.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_TOKEN_INVALID']);
          this.handleNetworkError();
        });

      this.chatWindowInstance.on('beforeWSSendMessage', (event: any) => {
        console.log('before ws send message: ', event);
      })
    }
    let languageSelected = this.getLanguageDetails();
    this.LanguageObject(languageSelected)   
  }; 
  
  getLanguageDetails(){
    let language = this.localStorageService.getLanguage();
    return language;
  }

  addBackWardCompatibility(agentassistSettings : any){
    if(agentassistSettings && (!agentassistSettings.feedback || !Object.keys(agentassistSettings.feedback)?.length)){
      agentassistSettings.feedback = this.rootService.defaultFeedbackSettings;
    }
    return agentassistSettings
  }


  hideSendAndCopy() {
    this.rootService.hideActionButtons = (this.rootService.connectionDetails.channel === ProjConstants.VOICE) ? true : false;

    if (this.rootService?.aaSettings?.isAgentResponseEnabled === false) {
        this.rootService.hideSendButton = true;
    }

    if (this.rootService?.aaSettings?.isAgentResponseCopyEnabled === false) {
        this.rootService.hideCopyButton = true;
    }

    if (this.rootService.hideSendButton && this.rootService.hideCopyButton) {
        this.rootService.hideActionButtons = true;
    }
}



  getAASettings(botId: string){
    const { channel } = this.rootService.connectionDetails;
    return fetchInstance('get_aa_settings', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },  this, { botId,  channel});
  }

  getAAPrefsSettings(botId: string){
    const { channel } = this.rootService.connectionDetails;
    const language = this.localStorageService.getLanguage()
    return fetchInstance('aa_prefs_settings',{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },     
    }, this,{botId, channel, lang:language, instanceBotId:botId})
  }

  
  JWTSetup(options: any, isJWE: boolean) {

    const { token, botId } = options.connectionDetails || {};

    var payload = {
      "assertion": token,
      "botInfo": {
        taskBotId: botId,
        chatBot: 'Sample Bot'
      },
      "token": {}
    }

    // const endPoint = isJWE ? 'jwt_load' : 'jwt_grant';
    const endPoint = this.config?.connectionDetails?.isSecure ? 'jwt_load' : 'jwt_grant';

    return fetchInstance(endPoint, {
      method: 'POST',
      body: JSON.stringify(payload),
    },  this);
  }

  render(chatWindowHtml: any) {
    this.clearContainer();
    const container = document.getElementsByClassName(this.config.container)[0];
    if(chatWindowHtml){
      container.append(chatWindowHtml);
    }
  };

  clearContainer(){
    let elements : any = document.getElementsByClassName(this.config.container);
    // Loop through each element and clear its children
    for (let i = 0; i < elements.length; i++) {
      while (elements[i].firstChild) {
        elements[i].removeChild(elements[i].firstChild);
      }
    }
  }

  renderLoader(){
    let loaderHtml = getHTML(AALoder,{}, this);
    this.emit(SDK_EVENTS.BEFORE_VIEW_INIT, loaderHtml, { event: SDK_EVENTS.MAIN_LOADER, data: {} });
    const container = document.getElementsByClassName(this.config.container)[0];
    container.append(loaderHtml);
  }

  removeLoader(){
    let loaderHtml = this?.chatEle?.querySelector(`#${IdMapConstant.LOADER_BLOCK_MAIN}`);
    loaderHtml?.remove();
  }

  renderIndividualLoader(container: any){
    this.removeIndividualLoader(container);
    let loaderHtml = getHTML(IndividualLoader,{}, this);
    this.emit(SDK_EVENTS.BEFORE_VIEW_INIT, loaderHtml, { event: SDK_EVENTS.INDIVIDUAL_LOADER, data: {} });
    container?.append(loaderHtml);
    setTimeout(() => {
      this.removeIndividualLoader(container);
    }, 5000);
  }

  removeIndividualLoader(parentNode : any){
    let loaderHtml = parentNode.querySelector(`#${IdMapConstant.LOADER_BLOCK_INDIVIDUAL}`);    
    loaderHtml?.remove();
  }

  bindEvents() {
    this.on('ON_SOCKET_CONNECTION', this.handleOnSocketConnectionEvent);
    this.on(DATA_EVENTS.ON_READY, this.handleOnReadyEvent);
    this.on(DATA_EVENTS.PREFS_RESPONSE, this.handlePrefsResponse)
  }

  handleOnReadyEvent = (data:any) => {
    if(this.rootService.isOnReadyCalled){
      return;
    }

    this.rootService.isOnReadyCalled = true;

    if(data?.aa_settings){
      this.settingsResponseHandler(data.aa_settings);
    }

    if(data?.aa_prefs){
      this.handlePrefsResponse(data.aa_prefs);
    }

    if(data?.internal_transfer_response){
      this.internalTransfer(data.internal_transfer_response);
    }

    this.updateSettingsProperties() 
    if(this.newSocketApproach){   
      this.commonEmitEvents(this.config);  
    }       
  
  }

  handleOnSocketConnectionEvent = (config: any) => {
    if(!this.newSocketApproach){
      this.commonEmitEvents(config);
    }
  }

  handlePrefsResponse=(data:any,isApiCall?:boolean)=>{
    const languageSelected = this.getLanguageDetails()
    const { channel,botId } = this.rootService.connectionDetails;
    let ordArr:any = []
    let loutcstObj:any = {}

    if(data?.prefs){
      this.rootService.prefsAccessObj.prefs = data.prefs[channel]?.locale[languageSelected]
      this.rootService.prefsAccessObj.orderTabs = data.prefs[channel]?.locale[languageSelected]?.lout?.ord;
      this.rootService.prefsAccessObj.defaultTab = data.prefs[channel]?.locale[languageSelected]?.lout?.dfTb;
      this.localStorageService.setActiveTab(this.rootService.prefsAccessObj.defaultTab)
      this.rootService.prefsOpacity = data.prefs[channel]?.locale[languageSelected]?.sg?.dT?.lbl?.scVsbty;
      ordArr = data.prefs[channel]?.locale[languageSelected]?.lout?.ord
    }
    else{
      this.rootService.prefsAccessObj.prefs = prefsSeed[languageSelected as keyof typeof prefsSeed]
      this.rootService.prefsAccessObj.orderTabs = prefsSeed[languageSelected as keyof typeof prefsSeed]?.lout?.ord;
      this.rootService.prefsAccessObj.defaultTab = prefsSeed[languageSelected as keyof typeof prefsSeed]?.lout?.dfTb;
      this.localStorageService.setActiveTab(this.rootService.prefsAccessObj.defaultTab)
      this.rootService.prefsOpacity = prefsSeed[languageSelected as keyof typeof prefsSeed]?.sg?.dT?.lbl?.scVsbty || 50;
    } 


    if(data?.prefs && ordArr && ordArr?.length){
      loutcstObj = ordArr.find((item:any)=> item.hasOwnProperty('cst'))
      if(loutcstObj && loutcstObj?.cst && loutcstObj?.cst?.isE){
        this.rootService.customTabPrefsObj.customTabEnabled = loutcstObj.cst?.isE;
        this.rootService.customTabPrefsObj.customTabPrefs = loutcstObj.cst
        this.rootService.customTabPrefsObj.customTabWlD = loutcstObj.cst?.[botId]?.wfD?.isE ? loutcstObj.cst?.[botId]?.wfD?.dgIds : [];
        this.rootService.customTabPrefsObj.customTablbl = loutcstObj.cst?.lbl || '';
      }
    }

    if(isApiCall){
      this.updateSettingsProperties();
    }
    
  }


  cleanupEvents(){
    this.off(DATA_EVENTS.SETTINGS_RESPONSE, this.settingsResponseHandler);
    this.off('ON_SOCKET_CONNECTION', this.handleOnSocketConnectionEvent);
    this.off(DATA_EVENTS.ON_READY, this.handleOnReadyEvent);
    this.off(DATA_EVENTS.PREFS_RESPONSE, this.handlePrefsResponse);
  }

  commonEmitEvents(config: any) {

    const { botId, conversationId, autoBotId, interactiveLanguage, userName, customData, token, channel } = config?.connectionDetails;
    let sendCustomData = '';
    let sendInteractiveLanguage = '';
    let sendAutoBotId = '';

    if (customData && Object.keys(customData)?.length > 0 && config?.connectionDetails?.source !== 'smartassist-color-scheme') {
      sendCustomData = customData
    };

    if (interactiveLanguage !== null && typeof interactiveLanguage !== 'undefined' && interactiveLanguage !== "''") {
      sendInteractiveLanguage = interactiveLanguage; // Return the default value for null, undefined, or "''"
    };

    if (autoBotId && autoBotId !== 'undefined') {
      sendAutoBotId = autoBotId;
    };

    let welComeMsgReqParam: any = {
      "waitTime": 2000,
      "userName": userName,
      "id": conversationId,
      "isSendWelcomeMessage": true,
      "agentassistInfo": {},
      "botId": botId,
      "sendMenuRequest": true,
      "uId": "",
      "sId": "",
      "experience": channel,
      "jToken": token,
      "conversationId": conversationId,
      "autoBotId": sendAutoBotId,
      "language": sendInteractiveLanguage,
      "allQueryParams": config?.connectionDetails,
      "customData": sendCustomData,
    };

    this.welComeMsgReq(welComeMsgReqParam);

    let overrideMode = this.rootService.proactiveMode ? false : true;
    this.handleOverrideMode(overrideMode, null);

    let menuReqParam = {
      "botId": botId,
      "conversationId": conversationId,
      "experience": channel,
      "autoBotId": sendAutoBotId,
      "language": sendInteractiveLanguage
    };

    this.menuReq(menuReqParam);

    if(this.rootService.isAnonymousFlowEnabled && !this.rootService.isAnonymousFlowTriggered && !this.rootService.isInitialInternalTransferTriggered){
      const localstorageData = this.localStorageService.getInternalTransferInfo();
      if(!this.rootService.internalTransfer && !Object.keys(localstorageData?.participant || {})?.length && !this.rootService.isHooksApi){
        this.rootService.isAnonymousFlowTriggered = true;
        this.internalTransfer({
          isAnonymousAgent: true
        });
      }
    }

    if(this.rootService.isInitialInternalTransferTriggered){
      const localstorageData = this.localStorageService.getInternalTransferInfo();
      this.rootService.isInitialInternalTransferTriggered = false;
      if(localstorageData){
        this.internalTransfer(localstorageData);
      }
    }
  }

  prepareAgentAssistRequestParams(data : any) {
    let agent_assist_request : any = {
      'conversationId': data.conversationId,
      'query': data.value,
      'botId': data.botId,
      'agentId': '',
      'experience': data?.channel,
      'positionId': data.positionId,
      'intType': 'assist'
    }
    if (data.intentName) {
      agent_assist_request['intentName'] = data.value;
    }
    if (data.entities) {
      agent_assist_request['entities'] = data.entities;
    } else {
      agent_assist_request['entities'] = [];
    }
    if (data.childBotId) {
      agent_assist_request['childBotId'] = data.childBotId;
    }
    if (data.childBotName) { 
      agent_assist_request['childBotName'] = data.childBotName;
    }
    if (data?.autoBotId && data?.autoBotId !== 'undefined') {
      agent_assist_request['autoBotId'] = data.autoBotId;
    } else {
      agent_assist_request['autoBotId'] = '';
    }
    if (data.intentName && data.userInput) {
      agent_assist_request['query'] = data.userInput
    }
    if (this.rootService.isAutomationOnGoing) {
      agent_assist_request['positionId'] = this.rootService.currentPositionId;
    }
    if(Array.isArray(data.traits) && data?.traits?.length){
      agent_assist_request['traits'] = data.traits
    }

    if(data.taskRefId){
      agent_assist_request['taskRefId'] = data.taskRefId
    }

    if(data.dialogId){
      agent_assist_request['dialogId'] = data.dialogId
    }

    if(data.isDiscard){
      agent_assist_request['terminateTask'] = data.isDiscard
    }

    if(data?.attachments) {
      agent_assist_request['query'] = data?.attachments[0]?.url?.fileUrl || '';
      agent_assist_request['attachments'] = data?.attachments;
    }

    if(data?.author) {
      agent_assist_request['firstName'] = data?.author?.firstName || '';
      agent_assist_request['lastName'] = data?.author?.lastName || '';
      agent_assist_request['type'] = data?.author?.type || '';
    }

    agent_assist_request = this.addSourceMsgIdToRequestParams(data,agent_assist_request)

    return agent_assist_request;
  }


  prepareAgentAssistAgentRequestParams(data : any) {
    let agent_assist_agent_request_params: any = {
      'isSearch': data.isSearch,
      'conversationId': data.conversationId,
      'query': data.value,
      'botId': data.botId,
      'experience': data?.channel,
      'positionId': data?.positionId,
      'childBotId': data?.childBotId || '',
      'childBotName': data?.childBotName || '',
      'intType': 'myBot'
    }
    if (data.intentName) {
      agent_assist_agent_request_params.intentName = data.intentName;
    }
    // if(data.childBotId) {
    //   agent_assist_agent_request_params['childBotId'] = data.childBotId;
    //   agent_assist_agent_request_params['childBotName'] = data.childBotName;
    // }
    if (data?.autoBotId && data?.autoBotId !== 'undefined') {
      agent_assist_agent_request_params['autoBotId'] = data.autoBotId;
    } else {
      agent_assist_agent_request_params['autoBotId'] = '';
    }
    if (data.intentName && data.userInput) {
      agent_assist_agent_request_params['query'] = data.userInput
    }

    // if (this.isMyBotAutomationOnGoing) {
    //   agent_assist_agent_request_params['positionId'] = this.currentPositionIdOfMyBot;
    // }

    if(Array.isArray(data.traits) && data?.traits?.length){
      agent_assist_agent_request_params['traits'] = data.traits
    }

    if(data.taskRefId){
      agent_assist_agent_request_params['taskRefId'] = data.taskRefId
    }

    if(data.dialogId){
      agent_assist_agent_request_params['dialogId'] = data.dialogId
    }

    if(data.isDiscard){
      agent_assist_agent_request_params['terminateTask'] = data.isDiscard
    }

    if(data?.attachments) {
      agent_assist_agent_request_params['query'] = data?.attachments[0]?.url?.fileUrl || '';
      agent_assist_agent_request_params['attachments'] = data?.attachments;
    }

    agent_assist_agent_request_params = this.addSourceMsgIdToRequestParams(data,agent_assist_agent_request_params)
    
    return agent_assist_agent_request_params;
  }

  prepareAgentAssistCustomRequestParams(data : any) {
    let agent_assist_agent_request_params: any = {
      'isSearch': data.isSearch,
      'conversationId': data.conversationId,
      'query': data.value,
      'botId': data.botId,
      'experience': data?.channel,
      'positionId': data?.positionId,
      'childBotId': data?.childBotId || '',
      'childBotName': data?.childBotName || '',
      'intType': 'custom',
      'crId': 'custom'
      
    }
    if (data.intentName) {
      agent_assist_agent_request_params.intentName = data.intentName;
    }
    // if(data.childBotId) {
    //   agent_assist_agent_request_params['childBotId'] = data.childBotId;
    //   agent_assist_agent_request_params['childBotName'] = data.childBotName;
    // }
    if (data?.autoBotId && data?.autoBotId !== 'undefined') {
      agent_assist_agent_request_params['autoBotId'] = data.autoBotId;
    } else {
      agent_assist_agent_request_params['autoBotId'] = '';
    }
    if (data.intentName && data.userInput) {
      agent_assist_agent_request_params['query'] = data.userInput
    }

    if(Array.isArray(data.traits) && data?.traits?.length){
      agent_assist_agent_request_params['traits'] = data.traits
    }

    if(data.taskRefId){
      agent_assist_agent_request_params['taskRefId'] = data.taskRefId
    }

    if(data.dialogId){
      agent_assist_agent_request_params['dialogId'] = data.dialogId
    }

    if(data.isDiscard){
      agent_assist_agent_request_params['terminateTask'] = data.isDiscard
    }

    if(data?.attachments) {
      agent_assist_agent_request_params['query'] = data?.attachments[0]?.url?.fileUrl || '';
      agent_assist_agent_request_params['attachments'] = data?.attachments;
    }

    if(data?.positionId){
      agent_assist_agent_request_params['positionId'] = data.positionId
    }

    agent_assist_agent_request_params = this.addSourceMsgIdToRequestParams(data,agent_assist_agent_request_params)
    
    return agent_assist_agent_request_params;
  }

  addSourceMsgIdToRequestParams(data : any,requestParams : any){
    if(data.sourceMsgId){
      if(data.sourceMsgId == 'fromLibrary'){
        requestParams['fromLibrary'] = true
      }else{
        requestParams['sourceMsgId'] = data.sourceMsgId
      }
    }
    return requestParams;
  }

  handleOverrideMode = (toggleOverride : any, dialogId : any) => {    
    let connectionDetails = this.rootService.connectionDetails;
    let overRideObj: any = {
      "agentId": "",
      "botId": connectionDetails.botId,
      "conversationId": connectionDetails.conversationId,
      "query": "",
      "enable_override_userinput": toggleOverride,
      'experience': this.rootService.connectionDetails?.channel,
      "positionId": dialogId
    }
    // this.rootService.proactiveMode = !toggleOverride;
    this.socketConnection.emitEvents(EVENTS.enable_override_userinput, overRideObj);
    this.rootService.OverRideMode = toggleOverride;
    
  }

  welComeMsgReq(welComeMsgReqParam: any) {
    this.socketConnection.emitEvents(EVENTS.welcome_message_request, welComeMsgReqParam);
  }

  menuReq(menuReqParam: any) {
    this.socketConnection.emitEvents(EVENTS.agent_menu_request, menuReqParam);
  }


  //events to handle from client
  // selectAAFooterTab(data : any){
  //   this.emit('selectTab', data , {});
  // }
  
  openAssistTab(footerTag : any){
      this.emit(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, {activeTab : 'ast', footerTag});
  }

  openTranscriptTab(footerTag : any){
    this.emit(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, {activeTab : 'trnspt', footerTag});
  }

  openSearchTab(footerTag : any){
    this.emit(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, {activeTab : 'srch', footerTag});
  }

  openMybotTab(footerTag : any){
    this.emit(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, {activeTab : 'mB', footerTag});
  }

  openCustomTab(footerTag : any){
    this.emit(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, {activeTab : 'cst', footerTag});
  }

  openPlaybookTab(footerTag : any){
    this.emit(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, {activeTab : 'playbook', footerTag});
  }

  sendChecklistOpenedEvent(checklistParams : any){
    this.emit(EVENTS_TO_SDK.CHECKLIST_OPEN, checklistParams);
  }

  sendChecklistResumeEvent(checklistParams : any){
    this.emit(EVENTS_TO_SDK.CHECLIST_RESUME, checklistParams);
  }

  sendChecklistStepCloseEvent(checklistParams : any){
    this.emit(EVENTS_TO_SDK.CHECKLIST_STEP_CLOSE, checklistParams);
  }

  sendChecklistProceedToCloseEvent(checklistParams : any){
    this.emit(EVENTS_TO_SDK.CHECKLIST_PROCEED_TO_CLOSE, checklistParams);
  }

  endOfConversation() {
    this.emit(INTERNAL_EVENTS.END_OF_CONVERSATION);
  }

  responseResolutionCommentsFromParent(resolutionComments : any){
    resolutionComments.openOnResponse = true;
    this.setSummaryPopup(resolutionComments);
  }

  setSummaryPopup(summaryPopup : any){
      this.emit(INTERNAL_EVENTS.SET_SUMMARY_POPUP, summaryPopup);
  }

  internalTransfer(data : any){
    if(!this.rootService.isInitialInternalTransferTriggered && !this.rootService.isOnReadyCalled){
      this.rootService.isInitialInternalTransferTriggered = true;
    }
    this.emit(INTERNAL_EVENTS.INTERNAL_TRANSFER, data);
  }

  disableWidget(isActive : boolean){
    this.emit(INTERNAL_EVENTS.DISABLE_WIDGET, isActive);
  }

  prepareTabs = (tabsNTitles: any, tabsTitles: any) => {
    let tabsRender:any[] = [];
    tabsNTitles.forEach((tab: any) => {
        const tabObj = Object.entries(tab);
        tabObj.forEach(([key, value]: any) => {
            if(value.isE){
                tabsRender.push({
                    type: key,
                    title: tabsTitles[key],
                    isEnabled: true,
                    default: key === this.rootService?.prefsAccessObj?.defaultTab
                })
            }
        })
    })

    if(this.rootService?.aaSettings[this.rootService?.connectionDetails?.channel]?.isAgentPlaybookEnabled){
      tabsRender.push({
        type: 'cl',
        title: tabsTitles['cl'],
        isEnabled: true,
        default: false
      })
    }

    if(tabsNTitles?.length > 0 && this.rootService?.aaSettings?.feedback?.widget?.isEnabled){
      tabsRender.push({
        type: 'mR',
        title: 'More',
        isEnabled: true,
        default: false
      })
    }

    return tabsRender;
  }

  applyBranding(colors: any, theme : string){
    if(theme === storageConst.DARK){
      colors = JSON.parse(JSON.stringify(DARKTHEME_COLORCODES));
      colors.primay = this.config?.branding?.colors?.primay;
    }
    const colorObj: any = {
      primay: '--AA-primary-color',
      secondary: '--AA-secondary-color',
      primaryText: '--AA-primary-text',
      secondaryText: '--AA-secondary-text',
      bodyBackground : '--AA-body-background',
      warningColor: '--AA-warning-color',
    };
    if(colorObj){
      for (const key in colorObj) {
        if (Object.prototype.hasOwnProperty.call(colorObj, key)) {
          const element = colorObj[key];
          document.documentElement.style.setProperty(element, colors[key]);
        }
      }
    }
  }

  destroy(){
    this.cleanupEvents();
    this.socketConnection.disconnect();
    this.emit('DESTROY_WIDGET', {});
    this.localStorageService.deleteLocalStorageState(this.rootService.connectionDetails.conversationId);
  }


  
handleNetworkError() {
  const toastElement = this.addNetworkErrorToastrTemplate();
  try {
      requestAnimationFrame(() => {
          this.rootService.showNetworkToastr(this);
          if (this.timeoutId !== undefined) {
              clearTimeout(this.timeoutId);
          }
          // this.timeoutId = window.setTimeout(() => {
          //     // this.rootService.hideNetworkToastr(this);
          // }, 5000);
      });
  } catch (error) {
      console.error('Error handling network toast:', error);
  }
}


private addNetworkErrorToastrTemplate() {
  try {
    const container = document.querySelector(`.${this.config.container}`);
    const toastContainer = container?.querySelector(`.${ClassMapConstanst.NETWORK_ERROR_TOASTR}`);
    if(!toastContainer){
      container?.classList?.add('container-border');
        const networkErrorToastTemplate : HTMLElement = getHTML(NetworkErrorToast, {}, this) as HTMLElement;
        // Add event listener for close button
        this.eventManager?.addEventListener(
            `.${ClassMapConstanst.NETWORK_ERROR_CLOSE_BTN}`,
            'click',
            () => {                
                this.rootService.hideNetworkToastr(this);
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }
            },
            networkErrorToastTemplate
        );
  
        // Emit event before adding to DOM
        this.emit(SDK_EVENTS.BEFORE_VIEW_INIT, networkErrorToastTemplate, {
            event: SDK_EVENTS.NETWORK_ERROR_TOASTR,
            data: {}
        });
  
        // Add to DOM
        if (!container) {
            throw new Error('Container not found');
        }
        
        container.appendChild(networkErrorToastTemplate);
        return networkErrorToastTemplate;
    }
      
  } catch (error) {
      console.error('Error adding network error toast template:', error);
      throw error;
  }
}

pauseTranscript(){
  this.emit(INTERNAL_EVENTS.PAUSE_TRANSCRIPT, 'pause');
}

resumeTranscript(){
  this.emit(INTERNAL_EVENTS.RESUME_TRANSCRIPT, 'resume');
}

}

export default AAWindow;
